export class NotUnique extends Error {
  constructor (payload) {
    super()
    this.message = payload.message
    this.display_text = payload.display_text
    if (payload.field) {
      this.field = payload.field
    }
    if (payload.fields) {
      this.fields = payload.fields
    }
    if (payload.errors) {
      this.errors = payload.errors
    }
  }
}

export class NotUniqueBucketUser extends Error {
  constructor (message) {
    super()
    this.message = message
  }
}
